import z from 'zod'
import { TinyRoleSchema } from './role'
import { CompanyIdSchema, TeamIdSchema } from './ids'
import { TinyTeamSchema, TinyUserSchema } from './entity'
import { CloserStatusSchema } from './closer'

export const SmallUserSchema = z
  .object({
    ...TinyUserSchema.shape,
    email: z.string().meta({ id: 'userEmail', description: "User's email address", example: 'john.smith@company.com' }),
    phone: z.string().optional().meta({ id: 'userPhone', description: "User's phone number", example: '5551234567' }),
    title: z
      .string()
      .optional()
      .meta({ id: 'userTitle', description: "User's job title", example: 'Sales Representative' }),
    timeZone: z
      .string()
      .optional()
      .meta({ id: 'userTimeZone', description: "User's timezone", example: 'America/Los_Angeles' }),
    teamIds: z.array(TeamIdSchema).optional().meta({ description: 'List of team IDs the user belongs to' }),
    closerStatus: CloserStatusSchema.optional().meta({
      id: 'userCloserStatus',
      description: "User's sales closing ability status",
      example: 'Can_Close',
    }),
    roles: z.array(TinyRoleSchema).optional(),
    memberOf: z.array(TinyTeamSchema.pick({ teamId: true, name: true })).optional(),
    companyId: CompanyIdSchema.optional(),
    createdDate: z
      .number()
      .optional()
      .meta({
        id: 'userCreatedDate',
        description: 'When the user was created, in UTC epoch milliseconds',
        example: 1672531200000,
      }),
  })
  .meta({
    id: 'smallUser',
    title: 'Small User',
    description: 'User information with basic contact details',
  })
export type SmallUser = z.infer<typeof SmallUserSchema>
